import ZmenaStadiaPage from './ZmenaStadiaPage';

export default ZmenaStadiaPage;
